import http from './http'
/**
 *  @parms resquest 请求地址 例如：
 *  @param '/testIp'代表vue-cil中config，index.js中配置的代理
 */
let resquest = "/api"
export default {
// 二期新增
	// 商品分类
	getProductCategory(params) {
		return http.post(`${resquest}/product/top_goods_category`, params)
	},
	// 热门商品
	getHotProduct(params) {
		return http.post(`${resquest}/index/top_goods`, params)
	},
	// 最新商品
	getNewsProduct(params) {
		return http.post(`${resquest}/index/new_goods`, params)
	},
	// 学习资料和操作说
	getMaterials(params) {
		return http.post(`${resquest}/skill/materials_top`, params)
	},
	// 意见反馈
	commitProposal(params) {
		return http.post(`${resquest}/about/proposal`, params)
	},
	
	
// ~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~~

	//获取轮播图
	getlunbo(params) {
        return http.get(`${resquest}/index/index`, params)
	},
	//首页产品
	getindexgoods(params) {
        return http.post(`${resquest}/index/product`, params)
	},
	//获取一级分类
    getoneCalss(params) {
        return http.post(`${resquest}/product/category`, params)
	},
	//登录
	Postlogin(params){
		return http.post(`${resquest}/login/login`,params)
	},
//技术支持
	//说明书列表
	Postexplain(params){
		return http.post(`${resquest}/skill/explain`,params)
	},
	//文献列表
	Postliterature(params){
		return http.post(`${resquest}/skill/literature`,params)
	},
	//资料索取
	Postdemand(params){
		return http.post(`${resquest}/skill/demand`,params)
	},
	//产品操作视频
	Postvideo(params){
		return http.post(`${resquest}/skill/product_video`,params)
	},
	//产品操作视频详情
	Postvideoinfo(params){
		return http.post(`${resquest}/skill/video_info`,params)
	},
	//新闻列表
	Postnewlist(params){
		return http.post(`${resquest}/news/lists`,params)
	},
	//新闻详情
	PostnewInfo(params){
		return http.post(`${resquest}/news/news_info`,params)
	},
	//学习资料
	Postmaterials(params){
		return http.post(`${resquest}/skill/materials`,params)
	},
	//实验工具
	Posttool(params){
		return http.post(`${resquest}/skill/tool`,params)
	},
	//获取一级分类下面的所有产品
	PostskillProduct(params){
		return http.post(`${resquest}/skill/product`,params)
	},
//活动中心
	//活动专区
	Postactivitylists(params){
		return http.post(`${resquest}/activity/lists`,params)
	},
	//活动详情
	Postactivityinfo(params){
		return http.post(`${resquest}/activity/info`,params)
	},
//走进同仁
	//公司介绍
	Postcomposer(params){
		return http.post(`${resquest}/about/composer`,params)
	},
	//联系我们
	Postcontact(params){
		return http.post(`${resquest}/about/contact`,params)
	},
	//联系我们页面
	Postcontactpage(params){
		return http.post(`${resquest}/about/contact_page`,params)
	},
	//订货流程
	PostorderingProcess(params){
		return http.post(`${resquest}/about/ordering_process`,params)
	},
	//加入我们
	Postjoin(params){
		return http.post(`${resquest}/about/join`,params)
	},
	//公司风采
	Postappearance(params){
		return http.post(`${resquest}/about/company_appearance`,params)
	},
//产品页
	//产品页面轮播图
	Postbanner(params){
		return http.post(`${resquest}/product/banner`,params)
	},
	//产品推荐新闻
	Postnews(params){
		return http.post(`${resquest}/product/news`,params)
	},
	//产品推荐
	PostTopProduct(params){
		return http.post(`${resquest}/product/top_product`,params)
	},
	//产品推荐分类
	PostTopCategory(params){
		return http.post(`${resquest}/product/top_category`,params)
	},
	//一级分类详情
	PostproductInfo(params){
		return http.post(`${resquest}/product/product_info`,params)
	},
	//根据二级ID获取产品列表
	PostproductList(params){
		return http.post(`${resquest}/product/product_list`,params)
	},
	//产品详情
	PostGoodsinfo(params){
		return http.post(`${resquest}/goods/info`,params)
	},
	//添加购物车
	PostGoodsadd(params){
		return http.post(`${resquest}/cart/add`,params)
	},
	//获取购物车数量
	PostGoodscount(params){
		return http.post(`${resquest}/Cart/goods_count`,params)
	},
	//获取购物车列表
	PostGoodsList(params){
		return http.post(`${resquest}/Cart/lists`,params)
	},
	//删除购物车
	PostGoodsrm(params){
		return http.post(`${resquest}/Cart/rm`,params)
	},
	//更新购物车数量
	PostGoodupdate(params){
		return http.post(`${resquest}/cart/update_number`,params)
	},
	//确认订单页面
	PostGoodcoupon(params){
		return http.post(`${resquest}/orders/goods_coupon`,params)
	},
	//生成订单
	PostordersCreate(params){
		return http.post(`${resquest}/orders/create`,params)
	},
//地址管理
	//获取地址三级菜单
	Postaddresstree(params){
		return http.post(`${resquest}/address/tree`,params)
	},
	//搜索单位
	Postuserunit(params){
		return http.post(`${resquest}/user/unit`,params)
	},
	//删除地址
	Postaddressdel(params){
		return http.post(`${resquest}/address/del`,params)
	},
	//添加地址
	Postaddressadd(params){
		return http.post(`${resquest}/address/add`,params)
	},
	//设为默认地址
	Postaddresssetdefault(params){
		return http.post(`${resquest}/address/set_default`,params)
	},
	//获取地址列表
	Postaddressget(params){
		return http.post(`${resquest}/address/get`,params)
	},
	//编辑地址
	Postaddressupdate(params){
		return http.post(`${resquest}/address/update`,params)
	},
//发票
	//发票抬头 搜索公司
	Postlook(params){
		return http.post(`${resquest}/user/look`,params)
	},
	//添加发票
	Postinvoiceadd(params){
		return http.post(`${resquest}/invoice/add`,params)
	},
	//发票列表
	Postinvoiceget(params){
		return http.post(`${resquest}/invoice/get`,params)
	},
	//设置默认发票
	Postinvoicegetsetdefault(params){
		return http.post(`${resquest}/invoice/set_default`,params)
	},
	//删除发票
	Postinvoicegetdel(params){
		return http.post(`${resquest}/invoice/del`,params)
	},
	//修改发票
	Postinvoicegetupdate(params){
		return http.post(`${resquest}/invoice/update`,params)
	},
//积分兑换
	//积分中心
	PostintegralList(params){
		return http.post(`${resquest}/product/integral_list`,params)
	},
	//积分商品详情
	PostGoods_coupon(params){
		return http.post(`${resquest}/Goods_integral/goods_coupon`,params)
	},
	//积分生成订单
	PostcreateOrder(params){
		return http.post(`${resquest}/Goods_integral/create_order`,params)
	},
	//积分订单详情
	Postordersinfo(params){
		return http.post(`${resquest}/user/integral_orders_info`,params)
	},
	//积分订单列表
	PostintegralOrders(params){
		return http.post(`${resquest}/user/integral_orders`,params)
	},
	//积分订单取消
	Postintegralcancel(params){
		return http.post(`${resquest}/user/cancel`,params)
	},
//订单
	//订单取消
	Postoredrcancel(params){
		return http.post(`${resquest}/orders/cancel`,params)
	},
	//订单详情
	Postoredrinfo(params){
		return http.post(`${resquest}/orders/info`,params)
	},
	//确认收货
	Postoredrconfirm(params){
		return http.post(`${resquest}/orders/confirm`,params)
	},
//用户操作
	//判断是否是VIP用户
	PostUseris_vip(params){
		return http.post(`${resquest}/user/is_vip`,params)
	},
	//我的积分
	Postintegral_log(params){
		return http.post(`${resquest}/user/integral_log`,params)
	},
	//我的发票
	PostuserInvoice(params){
		return http.post(`${resquest}/user/user_invoice`,params)
	},
	//获取vip说明
	PostuserCommon(params){
		return http.post(`${resquest}/index/common`,params)
	},
	//申请vip
	PostuserAudit(params){
		return http.post(`${resquest}/user/user_audit`,params)
	},
	//文件上传
	Postotherupload(params){
		return http.post(`${resquest}/other/upload`,params)
	},
	//浏览足迹
	Postuserbrowse(params){
		return http.post(`${resquest}/user/browse`,params)
	},
	//获取我的订单
	Postuserlists(params){
		return http.post(`${resquest}/orders/lists`,params)
	},
	//获取用户信息
	PostuserInfo(params){
		return http.post(`${resquest}/user/user_info`,params)
	},
	//修改用户信息
	Postuserupdate(params){
		return http.post(`${resquest}/user/update_info`,params)
	},
	//获取感兴趣实验
	PostuserExperiment(params){
		return http.post(`${resquest}/other/experiment`,params)
	},
	//我的留言
	PostuserMessage(params){
		return http.post(`${resquest}/user/message`,params)
	},
	//修改密码
	PostuserupdatePwd(params){
		return http.post(`${resquest}/user/update_password`,params)
	},
	//获取注册手机验证码
	PostphoneYzm(params){
		return http.post(`${resquest}/sms/massCode`,params)
	},
	//注册
	Postregistered(params){
		return http.post(`${resquest}/login/registered`,params)
	},
	//获取忘记密码手机验证码
	PostforgetPwd(params){
		return http.post(`${resquest}/login/forget_pass`,params)
	},
	//忘记密码确认验证码
	PostforgetpasCode(params){
		return http.post(`${resquest}/login/forget_pas_code`,params)
	},
	//忘记密码修改密码
	PostUserSetPwd(params){
		return http.post(`${resquest}/login/forget_pas`,params)
	},
	//登录二维码
	Postewm(params){
		return http.post(`${resquest}/login/login_qrcode`,params)
	},
	//搜索
	Postsearch(params){
		return http.get(`${resquest}/index/search`,params)
	},
	//是否关注关注公众号
	Postgonzhohao(params){
		return http.get(`${resquest}/login/query`,params)
	},
    // 成为会员配置
    GetMemberInfo(params){
        return http.get(`${resquest}/helper/user_config`, params)
	},
	//获取用户信息key
	GetUserBind_wx(params){
        return http.get(`${resquest}/user/bind_wx`, params)
	},
}
/*





*/

